//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('agencyManagementController', ['$scope', 'agencyManagement', '$stateParams', 'progressBar',
      'ngDialog',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state', 'authService', '$q', 'fileReader',
      'providers',
      function($scope, agencyManagement, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog,
        commonDialogMessage, $state, authService, $q, fileReader, providers) {
        let readyToUpload = false;
        let selectedFilename = null;
        $scope.showAllAgencies = agencyManagement.getShowAll();
        const progress = progressBar.getProgressBar();
        let gridData;
        $scope.organization = {
          Name: null,
          AddressLine1: null,
          AddressLine2: null,
          City: null,
          PostalCode: null,
          Country: null,
          StateProv: null,
          IsTravelAgency: true,
          Id: 0,
          TravelAgencyId: 0,
          HasConcur: false,
          Domains: {
            Id: 0,
            OrganizationId: 0,
            Name: null,
          },
          TripLinkAccounts: {
            Id: 0,
            OrganizationId: 0,
            Login: null,
            Password: null,
            ProviderId: 20,
            DataFetched: null,
          },
          AcceptEmails: {
            Id: 0,
            Email: null,
            OrganizationId: 0,
            IsAdmin: false,
          },
          LogoImageLink: '//:0'
        };
        $scope.isEdit = false;
        $scope.isNew = false;
        $scope.currentDate = new Date();
        $scope.domainList = [{
          Id: 0,
          Name: '',
          OrganizationId: 0,
        }, ];
        $scope.acceptEmailList = [{
          Id: 0,
          Email: '',
          OrganizationId: 0,
          IsAdmin: false,
        }, ];
        $scope.travelAgencySelId = 0;
        $scope.searchAgencies = function() {
          agencyManagement.setShowAll($scope.showAllAgencies);
          setGridData();
        };
        agencyManagement.getCountries().then(function(responseData) {
          $scope.countryList = responseData.data;
        }, function(err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = `<p>${err.statusText}</p>`;
              $scope.errTitle = 'Organization Error';
            },],
          });
        });
        $scope.countryName = 'United States';
        agencyManagement.getStates().then(function(responseData) {
          $scope.stateList = responseData.data;
        }, function(err) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = `<p>${err.statusText}</p>`;
              $scope.errTitle = 'Organization Error';
            },],
          });
        });
        $scope.stateName = '';
        //Call this code while Edit organization
        let id = $stateParams.id;
        if (!!id) {
          getOrganizationById(id);
          $scope.isEdit = true;
        } else {
          agencyManagement.getAgencies($scope.showAllAgencies).then(function(response) {
            const agencies = response.data;
            $scope.travelAgencyList = agencies.map(function(organization) {
              return {
                Id: organization.Id,
                Name: organization.Name,
              };
            });
          });
        }

        function uploadImage(img) {
          if (img != null) {
            return providers.uploadImage(img).then(function(result) {
              const cloudinaryObj = result.data;
              //console.log(cloudinaryObj);
              const public_filename = cloudinaryObj.public_id + '.' + cloudinaryObj.format; // e.g. 'filename.jpg'
              return providers.transformImage(public_filename).then(function(result) {
                //console.log(result);
                return result.data;
              });
            });
          }
        };

        function deletePreviousImage(img) {
          if (img != null) {
            return providers.deleteImage(img).then(function (result) {
              return result.data;
            });
          }
        };


        // Validate trip link account , domian , accept email
        function validateEmailPass(addUpdate, addDomain, addEmail, addAccount) {
          let validateMessage = '';
          let inValidDomainList = null;
          let inValidEmailList = null;
          const emailRegex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          const domainRegex = /(^(https?):\/\/|^)(([^\.]+)\.([^\.]+\.[^\/$]+)|([^\.]+\.[^\/$]+))\/?$/;
          // Validate domain name and email address details while save /update.
          if (addUpdate) {
            if (!$scope.domainList[0].Name && !$scope.acceptEmailList[0].Email) {
              validateMessage = 'Either one domain name or one email address must be entered.';
              return validateMessage;
            };
            // validate domain name
            inValidDomainList = $scope.domainList.filter(function(domainlist) {
              return ((!domainRegex.test(domainlist.Name)) && (!!domainlist.Name));
            });
            if (!!inValidDomainList.length) {
              validateMessage = 'Entered domain name is invalid.';
              return validateMessage;
            };
            // validate accept email list
            inValidEmailList = $scope.acceptEmailList.filter(function(emailList) {
              return ((!emailRegex.test(emailList.Email)) && (!!emailList.Email));
            });
            if (!!inValidEmailList.length) {
              validateMessage = 'Entered email address is invalid.';
              return validateMessage;
            };
          };
          // validate domain name while adding new entry
          if (addDomain) {
            inValidDomainList = $scope.domainList.filter(function(domainlist) {
              return (!domainRegex.test(domainlist.Name));
            });
            if (!!inValidDomainList.length) {
              validateMessage = 'Valid domain name must be entered, before adding new entry.';
              return validateMessage;
            }
          };
          // validate email while adding new entry
          if (addEmail) {
            inValidEmailList = $scope.acceptEmailList.filter(function(emailList) {
              return (!emailRegex.test(emailList.Email));
            });
            if (!!inValidEmailList.length) {
              validateMessage = 'Valid email address must be entered, before adding new entry.';
              return validateMessage;
            }
          };
          return validateMessage;
        };

        function addAgency(agency) {
          agencyManagement.addOrganization(agency).then(function () {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add Agency Success';
                $scope.successMsg = 'The Agency has been added succesfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $state.go('app.agencyManagement');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Agency Error';
              },],
            });
          })
            .finally(function() {
              progress.complete();
            });
        };

        function getOrganizationById(id) {
          progress.start();
          const promiseClient = agencyManagement.getOrganizationById(id);
          const promiseAgency = agencyManagement.getAgencies($scope.showAllAgencies);
          $q.all([promiseClient, promiseAgency]).then(function(response) {
              $scope.isEdit = true;
              $scope.isNew = false;
              $scope.message = null;
              $scope.organization = response[0].data;
              //console.log($scope.organization);
              const agencies = response[1].data;
              $scope.travelAgencyList = agencies.map(function(agency) {
                return {
                  Id: agency.Id,
                  Name: agency.Name,
                };
              });
              $scope.domainList = ((!!response[0].data.Domains.length) ? response[0].data.Domains : [{
                Id: 0,
                Name: '',
                OrganizationId: 0,
              }, ]);
              $scope.countryName = response[0].data.Country;
              $scope.logoImageLink = response[0].data.LogoImageLink;
              $scope.stateName = response[0].data.StateProv;
              $scope.travelAgencySelId = response[0].data.TravelAgencyId;
              $scope.acceptEmailList = ((!!response[0].data.AcceptEmails.length) ? response[0].data.AcceptEmails : [{
                  Id: 0,
                  Email: '',
                  OrganizationId: 0,
                  IsAdmin: false,
                }, ]);
            }, function(err) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Agency Error';
                },],
              });
            })
            .finally(function() {
              progress.complete();
            });
        };

        function updateAgency(agency) {
          agencyManagement.updateOrganization(agency.Id, agency).then(function () {
            const dialogPut = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Update Agency Success';
                $scope.successMsg = 'The Agency has been updated succesfully.';
              },],
            });
            dialogPut.closePromise.then(function (data) {
              $state.go('app.agencyManagement');
            });
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Update Agency Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        };
        $scope.getFile = function() {
          fileReader.readAsDataUrl($scope.file, $scope)
            .then(function(result) {
              $scope.organization.LogoImageLink = result;
            });
        };
        $scope.setFile = function(event) {
          selectedFilename = event.target.files[0];
          readyToUpload = true;
          fileReader.readAsDataUrl(selectedFilename, $scope)
            .then(function(result) {
              $scope.organization.LogoImageLink = result;
            });
          $scope.$apply();
        };
        $scope.clearFile = function() {
          readyToUpload = false;
          selectedFilename = null;
          $scope.organization.LogoImageLink = '//:0';
          //$scope.$apply();
        };
        $scope.saveOrganization = function() {
          if ($scope.orgForm.$valid) {
            let validateEmailPassChk = validateEmailPass(true, false, false, true);
            if (!validateEmailPassChk) {
              let domainList = $scope.domainList.filter(function(domain) {
                return (!!domain.Name);
              });
              $scope.organization.Domains = ((!!domainList.length) ? domainList : []);
              $scope.organization.Country = $scope.countryName;
              $scope.organization.StateProv = $scope.stateName;
              let acceptEmailList = $scope.acceptEmailList.filter(function(acceptEmail) {
                return (!!acceptEmail.Email);
              });
              $scope.organization.AcceptEmails = ((!!acceptEmailList.length) ? acceptEmailList : []);
              progress.start();
              if (readyToUpload) {
                // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
                uploadImage(selectedFilename).then(function(result) {
                  if (result != null) {
                    if($scope.logoImageLink !== null) {
                      let str = $scope.logoImageLink;
                      let arrResult = str.split("/");
                      let len = arrResult.length-1;
                      str = arrResult[len];
                      let deletedFileName = str.substring(0, str.indexOf("."));
                      deletePreviousImage(deletedFileName).then(function(result) {
                        console.log(result);
                      });
                    }
                    $scope.organization.LogoImageLink = result;
                    addAgency($scope.organization);
                  }
                });
              } else {
                $scope.organization.LogoImageLink = $scope.logoImageLink;
                addAgency($scope.organization);
              }
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${validateEmailPassChk}</p>`;
                  $scope.errTitle = 'Agency Warning';
                },],
              });
            }
          }
        };
        $scope.updateOrganization = function(id) {
          if ($scope.orgForm.$valid) {
            let validateEmailPassChk = validateEmailPass(true, false, false, true);
            if (!validateEmailPassChk) {
              let domainList = $scope.domainList.filter(function(domain) {
                return (!!domain.Name);
              });
              $scope.organization.Domains = ((!!domainList.length) ? domainList : []);
              $scope.organization.Country = $scope.countryName;
              $scope.organization.StateProv = $scope.stateName;
              let acceptEmailList = $scope.acceptEmailList.filter(function(acceptEmail) {
                return (!!acceptEmail.Email);
              });
              $scope.organization.AcceptEmails = ((!!acceptEmailList.length) ? acceptEmailList : []);
              progress.start();
              if (readyToUpload) {
                // pipe raw to cloudinary, retrieve transformed cloudinary url and replace LogoImageLink
                uploadImage(selectedFilename).then(function(result) {
                  if (result != null) {
                    if($scope.logoImageLink !== null) {
                      let str = $scope.logoImageLink;
                      let arrResult = str.split("/");
                      let len = arrResult.length-1;
                      str = arrResult[len];
                      let deletedFileName = str.substring(0, str.indexOf("."));
                      deletePreviousImage(deletedFileName).then(function(result) {
                        console.log(result);
                      });
                    }
                    $scope.organization.LogoImageLink = result;
                    updateAgency($scope.organization);
                  }
                });
              } else {
                $scope.organization.LogoImageLink = $scope.logoImageLink;
                updateAgency($scope.organization);
              }
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${validateEmailPassChk}</p>`;
                  $scope.errTitle = 'Agency Warning';
                },],
              });
            }
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${validateEmailPassChk}</p>`;
                $scope.errTitle = 'Update Agency Warning';
              },],
            });
          }
        };
        //add new domain entry for organization
        $scope.addDomain = function() {
          let checkDomain = validateEmailPass(false, true, false, false);
          if (!checkDomain) {
            $scope.domainList.push({
              Id: 0,
              Name: '',
              OrganizationId: $scope.organization.Id,
            });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${checkDomain}</p>`;
                $scope.errTitle = 'Add Domain Warning';
              },],
            });
          }
        };
        //check duplicate domain entry for organization
        $scope.checkDuplicateDomain = function(index, domainName) {
          let domainList = $scope.domainList.filter(function(domain) {
            return (domain.Name == domainName);
          });
          if (domainList.length > 1) {
            const dialogDup = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${commonDialogMessage.duplicateDomainError}</p>`;
                $scope.errTitle = 'Update Traveler Error';
              },],
            });
            dialogDup.closePromise.then(function(data) {
              $scope.domainList[index].Name = '';
            });
          }
        };
        //Remove domain for organization
        $scope.removeDomain = function(index, domainId) {
          if (!domainId) {
            if ($scope.domainList.length > 1) {
              $scope.domainList.splice(index, 1);
            } else {
              if (!!$scope.domainList[0].Name) {
                $scope.domainList.splice(index, 1);
                $scope.domainList.push({
                  Id: 0,
                  Name: '',
                  OrganizationId: $scope.organization.Id,
                });
              } else {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${commonDialogMessage.blankDomainError}</p>`;
                    $scope.errTitle = 'Remove Domain Warning';
                  },],
                });
              }
            }
          } else {
            const confirm = ngDialog.open({
              template: 'templates/partials/viewConfirm.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete Domain?';
                $scope.strMsg = 'Do you really want to delete this domain?';
              },],
            });
            confirm.closePromise.then(function(data) {
              if (data.value === 1) {
                if ($scope.domainList.length > 1) {
                  $scope.domainList.splice(index, 1);
                } else {
                  if (!!$scope.domainList[0].Name) {
                    $scope.domainList.splice(index, 1);
                    $scope.domainList.push({
                      Id: 0,
                      Name: '',
                      OrganizationId: $scope.organization.Id,
                    });
                  } else {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${commonDialogMessage.blankDomainError}</p>`;
                        $scope.errTitle = 'Remove Domain Warning';
                      },],
                    });
                  }
                }
              }
            });
          }
        };
        //add new email entry for organization
        $scope.addEmail = function() {
          let checkAcceptEmail = validateEmailPass(false, false, true, false);
          if (!checkAcceptEmail) {
            $scope.acceptEmailList.push({
              Id: 0,
              Email: '',
              OrganizationId: $scope.organization.Id,
              IsAdmin: false,
            });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${checkAcceptEmail}</p>`;
                $scope.errTitle = 'Add Email Warning';
              },],
            });
          }
        };
        // ui-grid code
        const gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [{
            name: 'Name',
            displayName: 'Agency Name',
            enableHiding: false,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }, {
            name: 'AddressLine1',
            displayName: 'Address Line 1',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'AddressLine2',
            displayName: 'Address Line 2',
            visible: false,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'City',
            visible: true,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'StateProv',
            displayName: 'State',
            visible: true,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'PostalCode',
            displayName: 'Postal Code',
            visible: true,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Inactive',
            displayName: 'Inactive',
            visible: false,
            enableSorting: false,
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate: ' <span ng-show="row.entity.Inactive" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Inactive" style="padding-left: 5px;">No</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: 'true',
                label: 'Yes',
              }, {
                value: 'false',
                label: 'No',
              }, ],
            },
          }, {
            name: 'Country',
            visible: true,
            enableSorting: false,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'HasConcur',
            displayName: 'Has Concur',
            visible: false,
            enableSorting: false,
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate: ' <span ng-show="row.entity.HasConcur" style="padding-left: 5px;">{{row.entity.HasConcur}}eeeeeYes</span> <span ng-hide="row.entity.HasConcur" style="padding-left: 5px;">{{row.entity.HasConcur}}kkkkkNo</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: 'true',
                label: 'Yes',
              }, {
                value: 'false',
                label: 'No',
              }, ],
            },
          }, ],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
        };

        $scope.gridDetails =  _.cloneDeep(gridOptions);
        $scope.gridDetails.onRegisterApi = function(gridApi) {
            $scope.gridApi = gridApi;
            gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
             setGridData();
            });
            gridApi.selection.on.rowSelectionChanged($scope, function(row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
                if (row.entity.Inactive === true) {
                  $scope.disabledDeleteBtn = false;
                } else {
                  $scope.disabledDeleteBtn = true;
                }
              } else {
                $scope.rowSelecting = false;
                $scope.disabledDeleteBtn = false;
              }
            });
          };
        $scope.gridDetails.columnDefs[1].visible = ((authService.getLoginMember().Role === 4) ? true : false);
        $scope.onDblClick = function(row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view();
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };

        function setGridData() {
          progress.start();
          let promiseAgency = null;
          if (authService.getLoginMember().Role === 4) {
            promiseAgency = agencyManagement.getAgencies($scope.showAllAgencies);
          } else {
            promiseAgency = agencyManagement.getOrganizations();
          }

          promiseAgency.then(function (response) {
            const agencyData = response.data;              
            let agencies = [];
            if ($scope.showAllAgencies === false) {
              agencyData.forEach(function (agency) {
                if (agency.Inactive === false) {
                  agencies.push(agency);
                }
              });
            } else {
              agencies = response.data;
            }
            gridData = agencies;
            updateGridPagination(gridData);
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Agency Error';
              },],
            });
          })
          .finally(function () {
            progress.complete();
          });
        };
        setGridData();

        function updateGridPagination(gridData) {
          $scope.gridDetails.data = gridData;
          $scope.gridDetails.totalItems = gridData.length;
        };
        $scope.view = function() {
          if (!!$scope.rowSelectingId) {
            getOrganizationById($scope.rowSelectingId);
          }
          ngDialog.open({
            template: 'templates/partials/viewAgency.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
          });
        };
        $scope.deleteOrganization = function() {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Account?';
              $scope.strMsg = 'Do you really want to delete this account?';
            },],
          });
          confirm.closePromise.then(function(data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              agencyManagement.deleteOrganization($scope.rowSelectingId).then(function(response) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.strTitle = 'Delete Account Success';
                      $scope.successMsg = 'Your account has been deleted successfully';
                    },],
                  });
                  dialog.closePromise.then(function(data) {});
                }, function(err) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Delete Organization Error';
                    },],
                  });
                  dialog.closePromise.then(function(data) {});
                })
                .finally(function() {
                  progress.complete();
                  $scope.gridApi.core.clearAllFilters();
                  setGridData();
                });
            }
          });
        };
        $scope.edit = function() {
          $state.go('app.editAgency', {
            id: $scope.rowSelectingId,
          });
        };
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/agencyManagementController.js